import { render, staticRenderFns } from "./WorklistsPage.vue?vue&type=template&id=7bdffc47&scoped=true"
import script from "./WorklistsPage.vue?vue&type=script&lang=js"
export * from "./WorklistsPage.vue?vue&type=script&lang=js"
import style0 from "./WorklistsPage.vue?vue&type=style&index=0&id=7bdffc47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdffc47",
  null
  
)

export default component.exports